import { baseRequest } from "./base";

const getHomeItems = async (signal) => {
  var response = await baseRequest({ url: "/api/sliders", method: "GET", signal: signal });
  return response;
};

export { getHomeItems };
